import { gql } from "~/__generated__"

export const NEARBY_PLANS_QUERY = gql(/* GraphQL */ `
  query NearbyPlans(
    $latitude: Float!
    $longitude: Float!
    $distance: Float!
    $fromDatetime: ISO8601DateTime
  ) {
    nearbyPlans(
      latitude: $latitude
      longitude: $longitude
      distance: $distance
      fromDatetime: $fromDatetime
    ) {
      edges {
        node {
          id
          title
          description
          datetime
          minPeople
          maxPeople
          distance
          location {
            id
            name
          }
          planParticipations {
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
    viewer {
      id
    }
  }
`)
